import { DynamicLabel } from "./useDynamicI18n";

export enum ToastNotificationTypes {
  INFORMATION = 0,
  SUCCESS = 1,
  ERROR = 2,
  REWARD = 3,
}

export type ToastNotification = {
  id: string;
  title?: DynamicLabel;
  type: ToastNotificationTypes;
  label: DynamicLabel;
  duration?: number;
};

const notifications = ref<ToastNotification[]>([]);

const displayNotificationWithOptions = (options: Omit<ToastNotification, "id">) => {
  const toastNotification: ToastNotification = {
    id: crypto.randomUUID(),
    ...options,
  };
  notifications.value.unshift(toastNotification);
};

const displayNotification = (
  type: ToastNotificationTypes,
  label: DynamicLabel,
  duration: number = 5000,
) => {
  displayNotificationWithOptions({ type, label, duration });
};

const closeNotification = (index: number) => {
  if (!notifications.value[index]) {
    return;
  }
  notifications.value.splice(index, 1);
};

export const useToastNotifications = () => {
  const getNotifications = computed(() => notifications.value);
  return {
    toastNotifications: getNotifications,
    displayNotification,
    displayNotificationWithOptions,
    closeNotification,
  };
};
